import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
/**
 * The options object passed to a Requirable HOC.
 */

/**
 * Higher-Order Component that lets you render dynamic require()s as Components.
 *
 * Similar to UIComponents' [Loadable](https://git.hubteam.com/HubSpot/UIComponents/blob/11bb01e23bfb4dac200a5d12856618ac6feac082/UIComponents/static-3.1943/js/decorators/Loadable.tsx)
 * except that it defers the evaluation of JS that is part of the bundle
 * instead of async loading a code-split chunk.
 *
 * NOTE: the component created by Requirable is intentionally a class
 * component, not a functional component, to avoid `require` statements
 * triggering errors from `styled-components` dev-mode debug check
 * `checkDynamicCreation`
 *
 * `checkDynamicCreation` throws an error if it detects that `styled` is
 * called inside a functional component. This is meant to detect re-definition
 * of styled components inside a functional component (which is bad for
 * performance, as it results in a new component each time).
 *
 * However, this debug check also fires when a functional component uses `require`
 * to evaluate a module dynamically, even though the code that gets `required`
 * will only be executed once. When the required module (or other modules it
 * includes) call `styled` at the top level to define a new styled component, this
 * triggers the styled-called-in-a-functional-component detection.
 *
 * By making `RequirableComponent` a class component instead of a functional
 * component, Components can be defined once at the top level, but the `require`
 * won't run until they're rendered. Because they are class components, they
 * won't trigger the `checkDynamicCreation` dev-mode error.
 *
 * @param options - The options object that the Requirable HOC expects
 *
 * @example
 * ```typescript
 * const MyRequirableComponent = Requirable({
 *   loader: () => {
 *     const mod = require('./MyExpensiveComponent'),
 *     return mod.default || mod;
 *   },
 * });
 * ```
 */
export default function Requirable(options) {
  class RequirableComponent extends Component {
    constructor(props) {
      super(props);
      this.Component = options.loader();
    }

    render() {
      if (this.Component) {
        return /*#__PURE__*/_jsx(this.Component, Object.assign({}, this.props));
      }

      return null;
    }

  }

  RequirableComponent.displayName = 'Requirable';
  return RequirableComponent;
}